<template>
  <CWrapper>
    <div class="c-body" style="margin-top: -2rem!important;">
      <main class="c-main" style="padding-top:0rem !important;">
        <!--<div class="app" style="margin-left:-15px; margin-right:-15px;">-->
        <CRow>
          <CCol style="width: 50%;padding: 4px;">
            <select
              class="form-control"
              style="font-weight: bold; font-size:18px;"
              @change="reloadData()"
              v-model="selectedData"
            >
              <option
                v-for="item in companyResult"
                :value="item.Code"
                :key="item.Code"
              >
                {{ item.Code }}
              </option>
            </select>
          </CCol>
          <CCol style="width: 50%;padding: 4px;">
            <select
              class="form-control"
              style="font-weight: bold; font-size:18px;"
              @change="reloadData()"
              v-model="selectedYear"
            >
              <option
                v-for="year in years()"
                v-if="year >= 2015"
                :value="year"
                >{{ year }}</option
              >
            </select>
          </CCol>
        </CRow>
        <br />
        <CRow>
          <CCol style="width: 100%;padding: 0px;margin-left: -5px;">
            <apexchart
              type="line"
              height="260"
              :options="chartOptions"
              :series="series"
            ></apexchart>
            <apexchart
              type="line"
              height="260"
              :options="chartOptions1"
              :series="series1"
            ></apexchart>
            <apexchart
              type="bar"
              height="260"
              :options="chartOptions2"
              :series="series2"
            ></apexchart>
          </CCol>
        </CRow>
      </main>
    </div>
  </CWrapper>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import VueApexCharts from "vue-apexcharts";
import CryptoJS from "crypto-js";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueCordova);
export default {
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      companyResult: [],
      selectedData: "",

      chartOptions: {
        chart: {
          height: 200,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454"],
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Profit and Lost",
          align: "left",
        },
        //                    dataLabels: {
        //    enabled: true,
        //    formatter: function (value, opts) {
        //        return value == null ? "" : "Rp. " + (value / 1000000).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + "M";
        //    },
        //    offsetX: -2,
        //    style: {
        //        fontSize: '7px',
        //        colors: ["#304758"],
        //    }
        //},
        markers: {
          size: 5,
        },
        yaxis: {
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            formatter: function(value) {
              return value == null
                ? ""
                : "Rp. " +
                    (value / 1000000000)
                      .toFixed(2)
                      .toString()
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
                    " M";
            },
          },
        },
        xaxis: {
          type: "string",
          enabled: true,
          categories: [],
          style: {
            fontSize: "7px",
            colors: ["#304758"],
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: false,
          offsetY: -2,
          offsetX: -5,
        },
      },
      series: [
        {
          name: "Total Amount",
          data: [],
          formatter: function(value) {
            return value == null
              ? ""
              : "Rp. " +
                  value
                    .toFixed(2)
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          },
        },
      ],

      chartOptions1: {
        chart: {
          height: 200,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454"],
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Profit and Loss Cumulative",
          align: "left",
        },
        //                    dataLabels: {
        //    enabled: true,
        //    formatter: function (value, opts) {
        //        return value == null ? "" : "Rp. " + (value / 1000000).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + "M";
        //    },
        //    offsetX: -2,
        //    style: {
        //        fontSize: '7px',
        //        colors: ["#304758"],
        //    }
        //},
        markers: {
          size: 5,
        },
        yaxis: {
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            formatter: function(value) {
              return value == null
                ? ""
                : "Rp. " +
                    (value / 1000000000)
                      .toFixed(2)
                      .toString()
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
                    " M";
            },
          },
        },
        xaxis: {
          type: "string",
          enabled: true,
          categories: [],
          style: {
            fontSize: "7px",
            colors: ["#304758"],
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: false,
          offsetY: -2,
          offsetX: -5,
        },
      },
      series1: [
        {
          name: "Total Amount",
          data: [],
          formatter: function(value) {
            return value == null
              ? ""
              : "Rp. " +
                  value
                    .toFixed(2)
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          },
        },
      ],

      chartOptions2: {
        chart: {
          height: 200,
          type: "bar",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454"],
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Expense and Income",
          align: "left",
        },
        dataLabels: {
          enabled: false,
          position: "middle",
          formatter: function(value, opts) {
            return value == null
              ? ""
              : "Rp. " +
                  (value / 1000000)
                    .toFixed(2)
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
                  "M";
          },
          offsetX: -2,
          style: {
            fontSize: "8px",
            colors: ["#304758"],
          },
        },
        markers: {
          size: 5,
        },
        yaxis: {
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            formatter: function(value) {
              return value == null
                ? ""
                : "Rp. " +
                    (value / 1000000000)
                      .toFixed(2)
                      .toString()
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
                    " M";
            },
          },
        },
        xaxis: {
          type: "string",
          enabled: true,
          categories: [],
          style: {
            fontSize: "7px",
            colors: ["#304758"],
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: false,
          offsetY: -2,
          offsetX: -5,
        },
      },
      series2: [],

      urlServer: "",
    };
  },
  methods: {
    updateChart() {
      const max = 90;
      const min = 20;
      const newData = this.series[0].data.map(() => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      });

      const colors = ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"];

      // Make sure to update the whole options config and not just a single property to allow the Vue watch catch the change.
      this.chartOptions = {
        colors: [colors[Math.floor(Math.random() * colors.length)]],
      };
      // In the same way, update the series option
      this.series = [
        {
          data: newData,
        },
      ];
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + index
      );
    },
    reloadData() {
      let data = localStorage.token;
      const paramComment = {
        Company: this.selectedData,
        Year: this.selectedYear,
      };
      if (this.selectedData != "undefined") {
        if (typeof data != "undefined") {
          const month = new Array();
          const amount = new Array();
          axios
            .post(`${this.urlServer}/Api/Dashboard/Profit/`, paramComment, {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + data,
              },
            })
            .then((res) => {
              console.log(res);
              res.data.forEach(function(entry) {
                month.push(entry.MonthName);
                amount.push(entry.Amount);
              });

              this.series = [
                {
                  data: amount,
                },
              ];

              this.chartOptions = {
                ...this.chartOptions,
                ...{
                  xaxis: {
                    categories: month,
                  },
                },
              };
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        } else {
          this.loading = false;
          this.$router.push({ path: "/pages/login" });
        }

        if (typeof data != "undefined") {
          const month = new Array();
          const amount = new Array();
          axios
            .post(
              `${this.urlServer}/Api/Dashboard/ProfitCummulative/`,
              paramComment,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res.data);
              res.data.forEach(function(entry) {
                month.push(entry.MonthName);
                amount.push(entry.Cummulative);
              });

              this.series1 = [
                {
                  data: amount,
                },
              ];

              this.chartOptions1 = {
                ...this.chartOptions1,
                ...{
                  xaxis: {
                    categories: month,
                  },
                },
              };
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        } else {
          this.loading = false;
          this.$router.push({ path: "/pages/login" });
        }

        if (typeof data != "undefined") {
          const month = new Array();
          const amountIn = new Array();
          const amountEx = new Array();
          axios
            .post(
              `${this.urlServer}/Api/Dashboard/ExpenseIncome/`,
              paramComment,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + data,
                },
              }
            )
            .then((res) => {
              console.log(res.data);
              res.data.forEach(function(entry) {
                month.push(entry.MonthName);
                if (entry.GeneralType == "Income") {
                  amountIn.push(entry.Amount);
                } else {
                  amountEx.push(entry.Amount);
                }
              });

              var months = month.filter(function(elem, index, self) {
                return index === self.indexOf(elem);
              });
              console.log(months);
              this.series2 = [
                {
                  name: "Income",
                  data: amountIn,
                  formatter: function(value) {
                    return value == null
                      ? ""
                      : "Rp. " +
                          value
                            .toFixed(2)
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                  },
                },
                {
                  name: "Expense",
                  data: amountEx,
                  formatter: function(value) {
                    return value == null
                      ? ""
                      : "Rp. " +
                          value
                            .toFixed(2)
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                  },
                },
              ];

              this.chartOptions2 = {
                ...this.chartOptions2,
                ...{
                  xaxis: {
                    categories: months,
                  },
                },
              };
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        } else {
          this.loading = false;
          this.$router.push({ path: "/pages/login" });
        }
      } else {
      }
      this.loading = false;
    },
  },
  beforeMount() {
    this.loading = true;
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    const urlS = url.toString(CryptoJS.enc.Utf8);
    this.urlServer = urlS;
    let data = localStorage.token;
    const paramComment = {
      Company: "PT. CAKRAWALA DINAMIKA ENERGI",
      Year: "2019",
    };

    const form = new FormData();
    form.append("CompanyOid", this.selectedData);
    let sendData = JSON.stringify(Object.fromEntries(form));
    if (typeof data != "undefined") {
      axios
        .post(`${urlS}/Api/General/GetCompany/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.companyResult = res.data;
        })
        .catch((error) => {
          Vue.$toast.open({
            message: error,
            type: "error",
            position: "bottom",
          });
        });
    } else {
      this.$router.push({ path: "/pages/login" });
    }
    //if (typeof data != 'undefined') {
    //    const month = new Array();
    //    const amount = new Array();
    //    axios.post('/Api/Dashboard/Profit/', paramComment, {
    //        headers: {
    //            'Content-Type': 'application/json',
    //            'Authorization': 'Bearer ' + data
    //        }
    //    })
    //        .then((res) => {
    //            console.log(res.data);
    //            res.data.forEach(function (entry) {
    //                month.push(entry.MonthName);
    //                amount.push(entry.Amount);
    //            });

    //            this.series = [{
    //                data: amount
    //            }];

    //            this.chartOptions = {
    //                ...this.chartOptions, ...{
    //                    xaxis: {
    //                        categories: month
    //                    }
    //                }
    //            }
    //            this.loading = false;
    //        })
    //        .catch((error) => {
    //            this.loading = false;
    //            console.error(error);
    //        });
    //} else {
    //    this.loading = false;
    //    this.$router.push({ path: '/pages/login' })
    //}

    //if (typeof data != 'undefined') {
    //    const month = new Array();
    //    const amount = new Array();
    //    axios.post('/Api/Dashboard/ProfitCummulative/', paramComment, {
    //        headers: {
    //            'Content-Type': 'application/json',
    //            'Authorization': 'Bearer ' + data
    //        }
    //    })
    //        .then((res) => {
    //            console.log(res.data);
    //            res.data.forEach(function (entry) {
    //                month.push(entry.MonthName);
    //                amount.push(entry.Cummulative);
    //            });

    //            this.series1 = [{
    //                data: amount
    //            }];

    //            this.chartOptions1 = {
    //                ...this.chartOptions1, ...{
    //                    xaxis: {
    //                        categories: month
    //                    }
    //                }
    //            }
    //            this.loading = false;
    //        })
    //        .catch((error) => {
    //            this.loading = false;
    //            console.error(error);
    //        });
    //} else {
    //    this.loading = false;
    //    this.$router.push({ path: '/pages/login' })
    //}

    //if (typeof data != 'undefined') {
    //    const month = new Array();
    //    const amountIn = new Array();
    //    const amountEx = new Array();
    //    axios.post('/Api/Dashboard/ExpenseIncome/', paramComment, {
    //        headers: {
    //            'Content-Type': 'application/json',
    //            'Authorization': 'Bearer ' + data
    //        }
    //    })
    //        .then((res) => {
    //            console.log(res.data);
    //            res.data.forEach(function (entry) {
    //                month.push(entry.MonthName);
    //                if (entry.GeneralType == "Income") {
    //                    amountIn.push(entry.Amount);
    //                } else {
    //                    amountEx.push(entry.Amount);
    //                }
    //            });

    //            var months = month.filter(function (elem, index, self) {
    //                return index === self.indexOf(elem);
    //            });
    //            console.log(months);
    //            this.series2 = [
    //                {
    //                    name: 'Income',
    //                    data: amountIn,
    //                    formatter: function (value) {
    //                        return value == null ? "" : "Rp. " + value.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    //                    }
    //                },
    //                {
    //                    name: 'Expense',
    //                    data: amountEx,
    //                    formatter: function (value) {
    //                        return value == null ? "" : "Rp. " + value.toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    //                    }
    //                }
    //            ];

    //            this.chartOptions2 = {
    //                ...this.chartOptions2, ...{
    //                    xaxis: {
    //                        categories: months
    //                    }
    //                }
    //            }

    //            if (res.data.length > 0) {
    //                this.show = true;
    //                this.showNotFound = false;
    //                this.result = res.data;
    //            } else {
    //                this.show = false;
    //                this.showNotFound = true;
    //            };
    //            this.loading = false;
    //        })
    //        .catch((error) => {
    //            this.loading = false;
    //            console.error(error);
    //        });
    //} else {
    //    this.loading = false;
    //    this.$router.push({ path: '/pages/login' })
    //}

    this.loading = false;
  },
};
</script>
